import makePlaceholder from './Placeholder'

export default makePlaceholder({
  imageSet: {
    1: require('./images/create-new-icon.jpg'),
    2: require('./images/create-new-icon@2x.jpg'),
    3: require('./images/create-new-icon@3x.jpg'),
  },
})
